import { combineReducers } from 'redux';
import organization from './organization.reducer';

const reducer = combineReducers({
	organization
});

export default reducer;
